import Vue from 'vue'
import Sidebar from './Sidebar'
import Dialog from './DiaLog/App'
import Nav from './Nav'
import Tab from './Tab'
import Star from './Star'
import Loading from './Loading'
import Pagination from './pagination'
import Charge from './Charge'
import Modal from './Modal'
import Radio from './Radio'
import _holidayWorkCharge from './holidayWorkCharge/main'
import _holidayWorkPay from './holidayWorkPay/main'
import computerRoom from './computerRoom'

Vue.component('Sidebar', Sidebar)
Vue.component('Dialog', Dialog)
Vue.component('Nav', Nav)
Vue.component('Tab', Tab)
Vue.component('Star', Star)
Vue.component('Loading', Loading)
Vue.component('Charge', Charge)
Vue.component('Pagination', Pagination)
Vue.component('computerRoom', computerRoom)
Vue.use(_holidayWorkCharge)
Vue.use(_holidayWorkPay)

export { Modal, Radio }



// WEBPACK FOOTER //
// ./src/UIO/index.js